<div *ngIf='componentReady' [formGroup]='inputForm' class='ReleaseReplayAction'>
  <div class='row'>
    <div class='col col-3'>
      <mat-label>Note</mat-label>
    </div>
    <div class='col col-9'>
      <editor [init]='{indent: false,contextmenu: false}'
              [init]='editorConfig'
              apiKey='04qovptin0uxhmjex1sltjkw5h9935gcohri0q9i29ixaebh'
              formControlName='note'></editor>
    </div>
  </div>
  <div *ngIf='managerEmail' class='row'>
    <div class='col col-9 offset-3'>
      <mat-checkbox class='mt-3' formControlName='ccManager'
      >CC <span>{{ managerEmail }}</span></mat-checkbox
      >
    </div>
  </div>
</div>
